import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { GalleryItem, ImageItem } from "ng-gallery";
import { InspirationRoomService } from "../../canvas/services/inspiration-rooms/inspiration-room.service";
import { OptionSelectorService } from "../../canvas/services/option-selector.service";
import { Area, Option, StyleChoice, StyleSelection } from "../../engine/models/models";
import { Utilities } from "../../helpers/utilities";
import { BingImageResult } from "../../models/BingImageResult";
import { InspirationRoomModel } from "../../models/InspirationRoomModel";
import { OptionTag, TagFilter } from "../../models/TagFilter";
import { BingService } from "../../services/bing.service";
import { BroadcastService } from "../../services/broadcast.service";
import { Globals } from "../../services/globals";
import { MediaService } from "../../services/media.service";
import { ImageSearchResultsComponent } from "../image-search-results/image-search-results.component";
import { Validators, Editor, Toolbar } from 'ngx-editor';
import { DiscussionNotesComponent } from "./discussion-notes/discussion-notes.component";
import { VideoType } from "../../enum";
import { VideoComponent } from "../video/video.component";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ImageViewerComponent } from "../image-viewer/image-viewer.component";
import { ImageViewerModel } from "../../models/ImageViewerModel";
import { debug } from "console";


@Component({
  selector: "selection",
  templateUrl: "selection.component.html",
  styleUrls: ["selection.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SelectionComponent implements OnInit {
  @Input() option: Option;
  @Input() parentArea: Area;
  @Input() selectedTag: string;
  @Output() closed = new EventEmitter<boolean>();
  isVisualizable: boolean;
  isNext = true;
  isPrev = true;
  currentOptionId: number;
  utilities: Utilities = new Utilities();
  availableRooms: InspirationRoomModel[] = [];
  allRooms: InspirationRoomModel[] = [];
  private _gallery: string[] = [];
  subscription: any;
  optionRemoveSubscription: any;
  loadOptionSubscription: any;
  oldQuantity = 1;
  stepCount = 0;
  updateTimeout: any;
  isExpand: boolean = true;
  childOptions: Option[];
  toolbar: Toolbar;
  editor: Editor;
  optionDetails: string;
  isLiked: boolean = false;
  constructor(public globals: Globals,
    private broadcastService: BroadcastService,
    private inspirationRoom: InspirationRoomService,
    private router: Router,
    private route: ActivatedRoute,
    private optionCreator: OptionSelectorService,
    private bingService: BingService,
    private mediaService: MediaService,
    public dialog: MatDialog,
    private changeDetection: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    private loader: NgxUiLoaderService) {

    // Scroll to top of screen
    window.scroll(0, 0);

    this.snackBar.dismiss();

    this.subscription = this.globals.engine.onOptionChanged().subscribe(option => {
      this.updateGalleryImages();
    });

    this.optionRemoveSubscription = this.globals.engine.onOptionRemoved().subscribe(option => {
      this.changeDetection.detectChanges();
    });

    this.loadOptionSubscription = this.optionCreator.updateJson.subscribe(option => {
      this.goBack();
    });
  }

  get singleAccordion(): boolean {
    if (this.displayedOption.details
      || (this.filter && this.filter.tags && this.filter.tags.length)
      || (this.option.appliedFilter && (this.displayedOption.isAdded || this.displayedOption.isSelected) && this.displayedOption.styleSelections)) {
      return false;
    }
    return true;
  };

  changeSelectedOption(option: Option, childOption: Option, isLiked: boolean) {
    this.globals.engine.selectOption(option.optionId, childOption.optionId, null, null, false);
    this.showAvailableRooms(childOption.optionId)
    this.onChangeQuantity(option);

  }
  //changeSelectedStyle() {
  //  globals.engine.selectOption(option.optionId, displayedOption.optionId, styleSelection.optionId, choice.optionId);
  //  collapse(styleSelection, last)
  //}
  ngOnInit() {
    this.isExpand = true;
    this.hidePrevNext();
    this.getSelectedOption();
    const option = this.option.selectedOption ?? this.option;
    if (this.option.selectedOption) {
      this.option = this.globals.engine.displayedOptions.filter(x => x.optionId == this.option.optionId)[0];   
    }
    if (!this.option.quantity) {
      this.option.quantity = 1;
    }
    this.oldQuantity = this.option.quantity;
    this.expandFirstStyleList();
    if (option && option !== null) {
      let optionId: number;
      if (this.option.selectedOption) {
        optionId = this.option.selectedOption.optionId;
      }
      else {
        optionId = this.option.optionId;
      }
      if (this.globals.allRooms && this.globals.allRooms) {
        this.allRooms = JSON.parse(JSON.stringify(this.globals.allRooms));
        this.showAvailableRooms(optionId);
      } else {
        this.inspirationRoom.listInspirationRooms().subscribe(response => {
          this.allRooms = response;
          this.globals.allRooms = JSON.parse(JSON.stringify(this.allRooms));
          this.showAvailableRooms(optionId);
        });
      }
    }
    this.editor = new Editor();
    this.updateGalleryImages();
  }

  ngAfterViewInit() {
    const globleOption = this.globals.engine.optionDefinitions.find(x => x.optionId == this.option.optionId);
    if (globleOption) {
      if (globleOption.filter) {
        this.option.filter = globleOption.filter;
      }
      if (globleOption.appliedFilter) {
        this.option.appliedFilter = globleOption.appliedFilter;
      }
    }
  }

  ngDoCheck() {
    if (this.option.childOptions && this.option.childOptions.length > 1) {
      this.option = this.orderByChildOptions(this.option);
    }
  }

  orderByChildOptions(option: Option): Option {
    let includeOptions = option.childOptions.filter(x => x.isIncludedFeature || x.isIncluded || !x.price || x.price == 0);
    let optionalOptions = option.childOptions.filter(x => !includeOptions.includes(x));
    option.childOptions = includeOptions.concat(optionalOptions);
    return option;
  }

  get filter(): TagFilter {
    let filter = this.globals?.engine?.tagFilter?.find(x => x.featureIds && x.featureIds.includes(this.option.optionId))
    if (filter) {
      let tags: OptionTag[] = []
      filter.tags.forEach((tag) => {
        if (this.option.childOptions.filter(x => x.tags && x.tags.includes(tag.tagName)).length) {
          tags.push(tag);
        }
      });
      filter.tags = tags;
      this.option.filter = filter
      const globleOption = this.globals.engine.optionDefinitions.find(x => x.optionId == this.option.optionId);
      if (globleOption) {
        globleOption.filter = filter;
      }

      if (this.option.appliedFilter) {
        this.childOptions = this.option.childOptions.filter(x => x.tags && x.tags.includes(this.option.appliedFilter))
      }
    } else {
      this.option.filter = undefined;
      this.option.appliedFilter = "N/A";
      this.childOptions = this.option.childOptions;
    }
    return filter;
  }

  applyFilter(tag: OptionTag) {
    if (this.option.appliedFilter === tag.tagName) {
      this.option.appliedFilter = undefined;
      this.childOptions = [];
      const globleOption = this.globals.engine.optionDefinitions.find(x => x.optionId == this.option.optionId);
      if (globleOption) {
        globleOption.appliedFilter = undefined;
      }
    } else {
      this.option.appliedFilter = tag.tagName;
      this.childOptions = this.option.childOptions.filter(x => x.tags && x.tags.includes(tag.tagName))
      const globleOption = this.globals.engine.optionDefinitions.find(x => x.optionId == this.option.optionId);
      if (globleOption) {
        globleOption.appliedFilter = tag.tagName;
      }
    }
    this.globals.engine.resetToIncludedFeature(this.option);
  }

  getLowestPrice(tag: OptionTag): number {

    let childOptions = this.option.childOptions.filter(x => x.tags && x.tags.includes(tag.tagName))
    childOptions = childOptions.sort((a, b) => (a.price < b.price) ? -1 : 1);
    return childOptions && childOptions.length ? (childOptions[0].price ? childOptions[0].price : 0) : 0;
  }

  get displayedOption(): Option {
    let displayedOption;
    if (this.option.childOptions && this.option.childOptions.length === 1) {
      displayedOption = this.option.childOptions[0];
    }
    this.getSelectedOption();
    if (this.filter && this.option.selectedOption) {
      if (this.childOptions) {
        const optionInFilter = this.childOptions.find(x => x.optionId == this.option.selectedOption.optionId)
        displayedOption = optionInFilter ? this.option.selectedOption : this.option;
      } else {
        displayedOption = this.option;
      }
    } else {
      displayedOption = this.option.selectedOption ?? this.option;
    }
    this.loader.stop();
    return displayedOption;
  }

  updateGalleryImages() {
    this._gallery = [];

    let uniquePictures = Array.from(new Set(this.option.selectedPictureGallery));

    for (let image of uniquePictures) {
      if (!image) {
        continue;
      }
      if (image && !image.includes("/assets/images")) {
        if (!image.includes("http")) {
          image = this.globals.engine.formatPictureUrl(image);
        }

        // Don't add the same image twice (for multiple style scenarios)
        this._gallery.push(image);
      }
    }

    // Show custom photos from Media Associations
    if (this.globals?.mediaAssociations?.length && this.option?.selectedOption) {
      const matches = this.globals.mediaAssociations.filter(q => q.optionId === this.option.selectedOption.optionId);

      if (matches?.length) {
        for (const match of matches) {
          this._gallery.push(match.contentUrl);
        }
      }
    }

    this.changeDetection.detectChanges();

  }

  expandFirstStyleList() {
    if (this.option.selectedOption) {
      if (this.option.selectedOption.styleSelections) {
        this.option.selectedOption.styleSelections[0].isExpand = true;
      }
    }
    else {
      if (this.option.styleSelections) {
        this.option.styleSelections[0].isExpand = true;
      }
    }
  }

  getSelectedOption() {
    if (this.option.childOptions) {
      for (const childOption of this.option.childOptions) {
        if (childOption.isSelected) {
          this.option.selectedOption = childOption;
          break;
        }
      }
    }
  }

  getChildOptionOrDefault(option: Option): string {
    if (option.defaultGalleryPictureMissing && option.styleSelections) {
      /* if (option.isStyleSelected) {*/
         for (const colorList of option.styleSelections) {
        colorList.styleChoices = colorList.styleChoices.sort((a: StyleChoice, b: StyleChoice) => {
          return a.displayName.localeCompare(b.displayName);
        });
        let choice = colorList.styleChoices.find(x => x.isSelected)
        if (choice && choice.pictureUrl) {
          return choice.pictureUrl;
        }
      }
      //}
    }
    return option.defaultGalleryPicture;
  }

  showAvailableRooms(optionid: number) {
    this.availableRooms = this.allRooms.filter(x => x.options && x.options.some(o => o.optionId === optionid))
  }

  //Quantity  never be blank or 0 or never >999.
  onChangeQuantity(option: Option) {
    if (option.quantity > 999) {
      option.quantity = 999;
    }

    this.displayedOption.quantity = option.quantity;

    if (!option.isSelected && !option.isAdded && !this.globals.engine.showRemoveButton(option)) {
      return;
    }

    this.updateQuantity(option);

    //clearTimeout(this.updateTimeout);
    //this.updateTimeout = setTimeout(() => {
    //  this.updateQuantity(option);
    //}, 1000);
  }

  onPaste(e, option: Option) {
    const value = e.clipboardData.getData('Text');
    if (value < 1 || value.includes(".")) {
      option.quantity = 1;
      return false;
    }
  }

  updateQuantity(option: Option) {
    if (option.quantity > 999) {
      option.quantity = 999;
    }
    if (option.quantity === 0 || option.quantity === null) {
      option.quantity = 1;
    }

    if (option.quantity && option.selectedOption && (option.isSelected || option.isAdded)) {
      this.globals.engine.setDirty();
      // this.globals.engine.updatePriceOnQuantityChange(option, this.oldQuantity);
      this.globals.engine.updateCalculations();
      this.oldQuantity = option.quantity;
    }
  }

  openInspirationRoomForOption(room: InspirationRoomModel, option: Option) {

    if (option.selectedOption) {
      this.currentOptionId = this.option.selectedOption.optionId;
    }
    else {
      this.currentOptionId = this.option.optionId;
    }
    setTimeout(() => {
      this.broadcastService.broadcast("SetBackButtonAreaName", this.parentArea.name);
    }, 200);
    this.router.navigate(['/inspirationRoomSelection/' + room.id + '/' + this.currentOptionId]);
  }

  review(option: Option) {

  }

  sortByPriceAscending(options: Option[]) {
    const sortedOptions = options.sort((a, b) => a.price - b.price);
    sortedOptions.forEach(d => { d.displayName = d.displayName !== "" && d.displayName !== null ? d.displayName : d.description });
    return sortedOptions;
  }

  sortOptionList(options: Option[]) {
    options.forEach(d => { d.displayName = d.displayName !== "" && d.displayName !== null ? d.displayName : d.description });
    let sortedOptions = options.sort((a, b) => (a.displayName < b.displayName) ? 1 : -1).sort((a, b) => (a.code > b.code) ? 1 : -1);
    sortedOptions = sortedOptions.filter(x => !x.code || x.code === "N/A").concat(sortedOptions.filter(x => x.code && x.code !== "N/A"))
    return sortedOptions;
  }

  selectedStyleDescription(choices: StyleChoice[]) {
    choices = choices.sort((a: StyleChoice, b: StyleChoice) => {
      return a.displayName.localeCompare(b.displayName);
    });
    const choice = choices.filter(q => q.isSelected);
    if (!choice.length) {
      return "Selection Needed";
    }
    return choice[0].description;
  }

  goBack() {
    this.closed.emit(true);
  }

  getAllOptions() {
    const allOptions = [];
    const options = this.globals.engine.optionsByArea(this.parentArea.id, this.globals.areas, this.selectedTag);
    if (options && options.length > 0) {
      for (const option of options) {
        allOptions.push(option);
      }
    }

    const optionalOptions = this.globals.engine.optionalOptionsByArea(this.parentArea.id, this.globals.areas, this.selectedTag);
    if (optionalOptions && optionalOptions.length > 0) {
      for (const optionalOption of optionalOptions) {
        allOptions.push(optionalOption);
      }
    }

    return allOptions;
  }

  hidePrevNext() {
    const allOptions = this.getAllOptions();
    if (allOptions.length <= 1) {
      this.isNext = false;
      this.isPrev = false;
    }
    if (allOptions && allOptions.length > 0) {
      var selectedOption = this.globals.previousSelectedOption;
      if (selectedOption) {
        const selectedItemIndex = allOptions.findIndex(x => x.optionId == selectedOption.optionId);
        if (selectedItemIndex === 0) {
          this.isPrev = false;
        }

        else if (selectedItemIndex === allOptions.length - 1) {
          this.isNext = false;
        }
      }
    }
  }

  onblur(option: Option) {
    if (!option.quantity) {
      option.quantity = 1;
    }
    this.onChangeQuantity(option);
  }

  prev() {
    const allOptions = this.getAllOptions();
    if (allOptions && allOptions.length > 0) {
      if (!this.isNext) {
        this.isNext = !this.isNext;
      }
      this._gallery = [];
      var selectedOption = this.globals.previousSelectedOption;
      if (selectedOption) {
        const selectedItemIndex = allOptions.findIndex(x => x.optionId == selectedOption.optionId);
        this.expandFirstStyleList();
        if (!selectedItemIndex || selectedItemIndex === -1) {
          this.isPrev = false;
        }
        else {
          this.option = allOptions[selectedItemIndex - 1];
          this.globals.previousSelectedOption = this.option;
        }

        if (selectedItemIndex - 1 === 0) {
          this.isPrev = false;
        }
      }
    }
    this.oldQuantity = this.option.quantity;
    if (this.option.selectedOption) {
      this.showAvailableRooms(this.option.selectedOption.optionId);

    }
    else {
      this.showAvailableRooms(this.option.optionId);
    }

    this.ngDoCheck();
  }

  allowOnlyNumbers(e, option: Option) {

    if (e.charCode < 48) {
      return false;
    }

    if (option.quantity?.toString().length > 2 && e.target.select()) {
      return false;
    }

    this.isExpand = true;
  }

  next() {
    const allOptions = this.getAllOptions();
    if (allOptions && allOptions.length > 0) {
      if (!this.isPrev) {
        this.isPrev = !this.isPrev;
      }
      this._gallery = [];
      const selectedOption = this.globals.previousSelectedOption;
      if (selectedOption) {
        const selectedItemIndex = allOptions.findIndex(x => x.optionId == selectedOption.optionId);
        this.expandFirstStyleList();
        if (selectedItemIndex === 0) {
          this.option = allOptions[selectedItemIndex + 1];
          this.globals.previousSelectedOption = this.option;
        }
        else if (!selectedItemIndex || selectedItemIndex === -1) {
          this.isNext = false;
        }
        else if (selectedItemIndex === allOptions.length - 1) {
          this.isNext = false;
        }
        else {
          this.option = allOptions[selectedItemIndex + 1];
          this.globals.previousSelectedOption = this.option;
        }

        if (selectedItemIndex + 1 === allOptions.length - 1) {
          this.isNext = false;
        }
      }
    }
    this.oldQuantity = this.option.quantity;
    if (this.option.selectedOption) {
      this.showAvailableRooms(this.option.selectedOption.optionId);

    }
    else {
      this.showAvailableRooms(this.option.optionId);
    }
    this.isExpand = true;
    this.ngDoCheck();
  }

  panelChange(styleSelection: StyleSelection) {
    styleSelection.isExpand = true;
    this.isExpand = false;
  }

  collapse(styleSelection: StyleSelection, isLast: boolean) {
    if (!isLast) {
      styleSelection.isExpand = false;
    }
  }

  // Admin Functionality

  potentialImagesResults: BingImageResult;

  openSearchTab(searchCriteria: string, newWindow = false) {

    if (this.option && !this.option.selectedOption) {
      this.option.selectedOption = this.option;
    }

    if (!searchCriteria) {

      searchCriteria = this.option.description;

      if (this.option?.selectedOption?.description && this.option?.selectedOption?.description !== "N/A") {
        searchCriteria = this.option?.selectedOption?.description;
      }

      if (this.option?.selectedOption?.model && this.option?.selectedOption?.model !== "N/A") {
        searchCriteria = this.option?.selectedOption?.model;
      }

      // Clean up any other terms that would make the search fail
      searchCriteria = searchCriteria.replace("Optional", "");
      searchCriteria = searchCriteria.replace("Included Feature", "");
    }

    this.bingService.getImagesByKeyword(searchCriteria).subscribe((thumbs) => {
      if (thumbs.value) {
        thumbs.value.map(image => {
          image.isSelected = false;
        });
      }

      this.mediaService.getMediaAssociations(this.option.selectedOption.optionId).subscribe(assc => {
        if (assc?.length) {
          for (const image of assc) {
            const matches = thumbs.value.filter(q => q.imageId === image.imageId);
            if (matches?.length) {
              for (const match of matches) {
                match.isSelected = true;
                match.isPrimaryImage = image.isPrimaryImage;
                match.isShownInPlace = image.isShownInPlace;
              }
            }
          }
        }

        // Don't open another instance of this dialog if it already exists
        if (!newWindow && thumbs.value) {

          const dialogRef = this.dialog.open(ImageSearchResultsComponent, {
            id: "image-search",
            minWidth: '80%'
          });

          dialogRef.afterOpened().subscribe(() => {
            thumbs.value = thumbs.value.sort((a, b) => +b.isSelected - +a.isSelected);
            dialogRef.componentInstance.thumbs = thumbs;
            dialogRef.componentInstance.mediaAssociations = assc;
            dialogRef.componentInstance.searchCriteria = searchCriteria;
            dialogRef.componentInstance.selectedOption = this.option.selectedOption;

            dialogRef.componentInstance.associationCreated.subscribe(association => {
              this.mediaService.createMediaAssociation(association).subscribe(() => {
                return;
              });
            });

            dialogRef.componentInstance.associationRemoved.subscribe(association => {
              this.mediaService.removeMediaAssociation(association).subscribe(() => {
                return;
              });
            });

            dialogRef.componentInstance.searchCriteriaUpdated.subscribe(searchCriteria => {
              this.openSearchTab(searchCriteria, true);
            });

            dialogRef.componentInstance.associationChanged.subscribe(association => {
              this.mediaService.updateMediaAssociation(association).subscribe(() => {
                return;
              });
            });
          });

          dialogRef.afterClosed().subscribe(() => {
            dialogRef.componentInstance.associationCreated.unsubscribe();
            dialogRef.componentInstance.associationRemoved.unsubscribe();
            dialogRef.componentInstance.associationChanged.unsubscribe();
            dialogRef.componentInstance.searchCriteriaUpdated.unsubscribe();
            return;
          });
        } else {
          this.dialog.getDialogById("image-search").componentInstance.thumbs = thumbs;
        }
      });
    });
  }

  selectAllContent($event) {
    $event.target.select();
  }

  setHeight() {
    let tiles = Array.from(document.getElementsByClassName('filter-tile'))
    var minheight = Math.max.apply(null, tiles.map(x => x.clientHeight));
    tiles.forEach(tile => {
      let element: any = tile;
      element.style.minHeight = `${minheight}px`;
    })
  }

  openNotes() {
    const oldNotes = this.displayedOption.discussionNotes;
    const notes = this.dialog.open(DiscussionNotesComponent, {
      data: this.displayedOption,
      width: '70%',
      disableClose: true
    });
    notes.afterClosed().subscribe(result => {
      if (oldNotes != this.displayedOption.discussionNotes) {
        this.globals.engine.setDirty();
      }
    })
  }

  openImageDialog(image: any) {
    let data: ImageViewerModel = {
      title: this.displayedOption.displayName,
      url: image
    }
    console.log(this._gallery)
    const dialogRef = this.dialog.open(ImageViewerComponent, {
      data: data,
      minWidth: '80%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      return;
    });
  }

}
